export default {"src":"/_next/static/media/two-wheeler-loan.dff0d3a0.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};